import { FilterButton } from '@/components/common/FilterButtons';
import { Input } from '@/components/common/Input';
import type { FormikProps } from 'formik';

interface GeneratePromoCodeFormProps {
  formik: FormikProps<{ discount: number }>;
  isPending: boolean;
}

export function GeneratePromoCodeForm({
  formik,
  isPending,
}: GeneratePromoCodeFormProps) {
  return (
    <div className="space-y-4">
      <form
        onSubmit={formik.handleSubmit}
        className="flex max-w-lg items-end gap-4"
      >
        <Input
          id="discount"
          name="discount"
          placeholder="Enter % value"
          label="Enter % value"
          className="border-input text-table-foreground mt-4 h-15"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.discount}
          error={
            formik.touched.discount && formik.errors.discount
              ? formik.errors.discount
              : undefined
          }
          touched={formik.touched.discount}
        />
        <FilterButton
          isPending={isPending}
          label={isPending ? 'Generating...' : 'Generate code'}
          onClick={formik.handleSubmit}
        />
      </form>
    </div>
  );
}
